import styled from 'styled-components';

export const DateChangeMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding: ${props.theme.spacing.large.l20} 0 ${props.theme.spacing.large.l30};
        border-bottom: 1px solid ${props.theme.colors.grey.lighte7};
    `
);

export const DateChangeInnerWrap= styled.div(
    props => `
        display: flex;
        flex-direction: column;
        margin-right: ${props.theme.spacing.large.l20};
    `
);

export const DateCheckLabel = styled.label(
    props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.grey.base};
        padding-bottom: ${props.theme.spacing.base};
    `
);

export const CalendarWrapper = styled.div(
  props => `
    display: flex;
    position: absolute;
    margin-top: ${props.theme.spacing.large.l15};
  `
)

export const DateCheckCalender = styled.p(
    props => `
        display: flex;
        align-items: center;
        border: 1px solid ${props.theme.colors.blue.lightd1};
        border-radius: 2px;
        box-shadow: inset 0 0 2px 0 #d1e2f5;
        padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l30} ${props.theme.spacing.base} ${props.theme.spacing.large.l12};
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.black.base};
        cursor: pointer;
        span{
            font-size: ${props.theme.font.large.font14};
            color: ${props.theme.colors.grey.base};
            padding-left: ${props.theme.spacing.base};
        }
    `
);
